import { render, staticRenderFns } from "./IconPickerInput.vue?vue&type=template&id=38d28466&scoped=true"
import script from "./IconPickerInput.vue?vue&type=script&lang=js"
export * from "./IconPickerInput.vue?vue&type=script&lang=js"
import style0 from "./IconPickerInput.vue?vue&type=style&index=0&id=38d28466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d28466",
  null
  
)

export default component.exports